import React, { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import ApplyRegularization from "../../pages/ApplyRegularization";
import HistoryRegularization from "./HistoryRegularization";
import PendingRegularization from "./pendingRegularization";
import { getToken, setToken } from "../../services/Token";
import { useDispatch, useSelector } from "react-redux";
import { Typography } from "@material-ui/core";
import { PersonSearch } from "@mui/icons-material";
import { useGetEmployeesListQuery } from "../../api/notificationApi";
import { setIsReviewRegularizationScreen, setRegularizationEmployeeId } from "../../store/reducers/regularizationSlice";

const ApplyRegularizationTabNavigation = () => {
  useGetEmployeesListQuery();
  const role = getToken('roles')
  const isAdmin = role ? role.includes("ADMIN") : false;
  const [selectedTab, setSelectedTab] = useState("apply");
  const [selectedEmployee , setSelectedEmployee] = useState('')
  const { employeesList } = useSelector((state) => state.notification);
  const { regularizationEmployeeId } = useSelector((state) => state.regularization);
  const dispatch = useDispatch()
  dispatch(setIsReviewRegularizationScreen(false))
  const onTabChange = (tabId) => {
    setSelectedTab(tabId);
  };
  console.log(selectedEmployee, regularizationEmployeeId,  'dfjkhaiuer')
  const [tabs, setTabs] = useState([
    {
      id: "apply",
      name: "Apply",
      content: <ApplyRegularization isAdmin={isAdmin} empId={selectedEmployee} />,
    },
    { id: "pending", name: "Pending", content: <PendingRegularization shoulShowApproveReject={false} shouldGetManagerRecords={true}/> },
    { id: "history", name: "History", content: <HistoryRegularization shouldGetManagerRecords={true}/> },
  ]);
  const selectedTabContent = tabs.find(
    (tab) => tab.id === selectedTab
  )?.content;

  const renderContent = () => {
    if (!isAdmin) {
      return selectedTabContent;
    } else if (isAdmin && selectedEmployee) {
      return selectedTabContent;
    } else {
      return (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          minHeight="60vh"
          p={3}
          textAlign="center"
        >
          <PersonSearch sx={{ fontSize: 80, color: "primary.main", mb: 2 }} />
          <Typography variant="h5" color="text.primary" gutterBottom>
            No Employee Selected
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Please select an employee to apply the regularization process.
          </Typography>
        </Box>
      );
    }
  };
  useEffect(() =>{
    setTabs((tabs) => {
      if(isAdmin){
        return tabs.filter(tab => tab.id === 'apply')
      }
      return tabs
    })
  },[])
  return (
    <>
      <Box className="flex justify-center" sx={{ mb: 3, pt: 6 }}>
        <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
          {tabs.map((tab) => (
            <Button
              key={tab}
              variant={selectedTab === tab?.id ? "contained" : "text"}
              onClick={() => onTabChange(tab?.id)}
              sx={{
                textTransform: "none",
                minWidth: 80,
                backgroundColor:
                  selectedTab === tab?.id ? "#2196F3" : "transparent",
                color: selectedTab === tab?.id ? "white" : "#666",
                border: "1px solid #2196F3",
              }}
            >
              {tab?.name}
            </Button>
          ))}
        </Box>
      </Box>
      {isAdmin && (
        <div className="w-[20%] m-5">
          <label
            htmlFor="audienceType"
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            Select Employee <span className="text-red-500">*</span>
          </label>
          <select
            id="selectEmployee"
            value={selectedEmployee}
            onChange={(e) => (
              setToken("regularizationEmployee", e.target.value),
              setSelectedEmployee(e.target.value),
              dispatch(setRegularizationEmployeeId(e.target.value))
            )}
            className="w-full !font-normal text-gray-700 p-3 bg-white border border-gray-300 rounded-lg hover:border-gray-600 cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
          >
            <option value="">Select Employee</option>
            {employeesList?.filter((each) => each?.role !== "MANAGER").map((option) => (
              <option key={option.employeeId} value={option.employeeId}>
                {option.name}
              </option>
            ))}
          </select>
        </div>
      )}
      {renderContent()}
    </>
  );
};

export default ApplyRegularizationTabNavigation;
